<template>
  <div class="home-markets">
    <div class="home-markets-top">
      <div class="earth-wrapper">
        <img src="../../assets/img/home/markets/earth.png" alt="Earth">
      </div>
      <div class="text-group">
        <h3 class="text-accent">{{ $t('home-markets-1') }}</h3>
        <h1>{{ $t('home-markets-2') }}</h1>
        <h2>{{ $t('home-markets-3') }}</h2>
        <h2>{{ $t('home-markets-3-1') }}</h2>
        <router-link to="/products?page=au" class="link">
          <span class="text-main-home">{{ $t('learn-more') }}</span>
        </router-link>
      </div>
      <div class="gold-bar-wrapper">
        <img src="../../assets/img/home/markets/gold.jpg" alt="Gold Bar">
      </div>
    </div>
    <div class="home-markets-bottom">
      <img src="../../assets/img/home/markets/people.jpg" alt="Personnel">
      <div class="text-group">
        <h3 class="text-accent">{{ $t('home-markets-4') }}</h3>
        <h1 class="text-light">{{ $t('home-markets-5') }}</h1>
        <h2 class="text-light">{{ $t('home-markets-6') }}</h2>
        <router-link to="/about" class="link">
          <span class="text-accent">{{ $t('learn-more') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.home-markets-top {
  display: flex;
  padding-left: $sidesPadding;
  .earth-wrapper {
    width: 11%;
    img {
      width: 100%;
    }
  }
  .text-group {
    width: 44%;
    padding: 20px 0 0 3%;
  }
  .gold-bar-wrapper {
    width: 45%;
    img {
      width: 100%;
    }
  }
}
.home-markets-bottom {
  align-items: flex-end;
  display: flex;
  justify-content: flex-end;
  padding: 0 $sidesPadding;
  position: relative;
  img {
    width: 87%;
    height: auto;
    position: relative;
    z-index: 1;
  }
  .text-group {
    background-color: $mainColor80;
    bottom: -20px;
    padding: 50px $sidesPadding 50px 30px;
    padding-right: $sidesPadding * 2;
    position: absolute;
    right: 0;
    width: 45%;
    z-index: 2;
  }
}
.home-markets-bottom::before {
  background-color: $mainColor;
  bottom: 0;
  content: "";
  height: 45%;
  position: absolute;
  left: 0;
  width: 50%;
}
@media screen and (max-width: 1600px) {
  .home-markets-top {
    padding-left: $sidesPadding1600;
  }
  .home-markets-bottom {
    padding: 0 $sidesPadding1600;
    .text-group {
      padding: 50px $sidesPadding1600 50px 30px;
      padding-right: $sidesPadding1600 * 2;
    }
  }
}
@media screen and (max-width: 1280px) {
  .home-markets-top {
    padding-left: $sidesPadding1280;
  }
  .home-markets-bottom {
    padding: 0 $sidesPadding1280;
    .text-group {
      padding: 50px $sidesPadding1280 50px 30px;
      padding-right: $sidesPadding1280 * 2;
    }
  }
}
@media screen and (max-width: 1000px) {
  .earth-wrapper {
    display: none;
  }
  .home-markets-top {
    background-image: url("../../assets/img/home/markets/gold.jpg");
    background-position: center;
    background-size: auto 100%;
    background-repeat: no-repeat;
    padding: 0 $sidesPadding1280;
    position: relative;
    .text-group {
      padding-left: 0;
      width: 100%;
      h1 {
        margin-bottom: 40vw;
      }
    }
    .gold-bar-wrapper {
      display: none;
    }
  }
  .home-markets-bottom {
    padding: 0;
    flex-direction: column;
    img {
      width: 100%;
    }
    .text-group {
      background-color: $mainColor;
      bottom: initial;
      margin-top: -50px;
      position: relative;
      right: initial;
      width: calc(100% - 40px);
    }
  }
  .home-markets-bottom::before {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .home-markets-top {
    background-size: 100% auto;
    padding: 0 $sidesPadding600;
    .text-group {
      // padding-top: 0;
      h1 {
        margin-bottom: 50vw;
      }
    }
  }
  .home-markets-bottom {
    .text-group {
      padding-bottom: 25px;
      padding-top: 25px;
      padding-right: 30px;
      width: calc(100% - 20px);
    }
  }
}
</style>

